import React from 'react'
//import SecNavigation from './sec-navigation.component'
import SecNavigation from './sec-navigation.lang.component'
import Navigation from './navigation.component'

/**
 * The header part of the layout
 *
 * @author Pragya Gupta
 */

const Header = ({
  user,
  navItems,
  handleManualLogout,
  showNotiDialog,
  getUserCompanyUpdateInfo,
  openCompanyNotificationDialog,
  closeCompanyNotificationDialog,
  notiIsNotRead,
  setReadCompanyUpdate
}) => (
  <>
    {!user ? (
      <Navigation />
    ) : (
      <SecNavigation
        user={user}
        navItems={navItems}
        handleManualLogout={handleManualLogout}
        showNotiDialog={showNotiDialog}
        getUserCompanyUpdateInfo={getUserCompanyUpdateInfo}
        openCompanyNotificationDialog={openCompanyNotificationDialog}
        closeCompanyNotificationDialog={closeCompanyNotificationDialog}
        notiIsNotRead={notiIsNotRead}
        setReadCompanyUpdate={setReadCompanyUpdate}
      />
    )}
  </>
)

export default Header
